// TeamManagement.js
import React from 'react';
import { Typography, Box, Button, Link, useTheme } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid'; // or from '@material-ui/data-grid' based on your version
import Header from "../global/Header";
import { tokens } from "../../../theme"
import {
    AdminPanelSettingsOutlined,
    LockOutlined,
    SecurityOutlined
} from "@mui/icons-material";







const TeamManagement = ({ organization_id, filtered_users }) => {
    const theme = useTheme();

    const colors = tokens(theme.palette.mode);
    const user_columns = [
        { field: "id", headerName: "ID" },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            cellClassName: "name-column--cell",
        },
        {
            field: "organization_id",
            headerName: "Organization ID",
            headerAlign: "left",
            align: "left",
        },
        {
            field: "organization_name",
            headerName: "Organization Name",
            headerAlign: "left",
            align: "left",
            flex: 1,
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
        },
        {
            field: "role",
            headerName: "Access Level",
            flex: 1,
            renderCell: ({ row: { role } }) => {
                return (
                    <Box
                        width="60%"
                        m="0 auto"
                        p="5px"
                        display="flex"
                        justifyContent="center"
                        backgroundColor={
                            role === "Admin"
                                ? colors.greenAccent[600]
                                : role === "Manager"
                                    ? colors.greenAccent[700]
                                    : colors.greenAccent[700]
                        }
                        borderRadius="4px"
                    >
                        {role === "Admin" && <AdminPanelSettingsOutlined />}
                        {role === "Manager" && <LockOutlined />}
                        {role === "User" && <SecurityOutlined />}
                        <Typography color={colors.grey[100]} sx={{ ml: "5px" }}>
                            {role}
                        </Typography>
                    </Box>
                );
            },
        },
        {
            field: "username",
            headerName: "Actions",
            cellClassName: "name-column--cell",
            flex: 1,
            renderCell: (params) => {
                return <div>
                    <Box display="flex" justifyContent="space-between">
                        <Link to={`/console/users/${params.value}`} color="secondary" variant="contained">
                            <Button display="flex" justifyContent="space-between" variant="contained">View</Button>
                        </Link>
                        <Link to={`/console/users/${params.value}/edit`} color="secondary" variant="contained">
                            <Button display="flex" justifyContent="space-between" variant="contained">Edit</Button>
                        </Link>
                    </Box>

                </div>;
            },
        },
    ];
    return (
        <Box m="20px">
            <Box display="flex" justifyContent="end" mt="20px">
                <Link to={`/console/organization/${organization_id}/users/new`} color="secondary" variant="contained">
                    <Button display="flex" justifyContent="space-between" variant="contained">Register New User</Button>
                </Link>
            </Box>
            <Header title="TEAM" subtitle="Managing the Team Members" />
            <Box
                m="40px 0 0 0"
                height="75vh"
                sx={{
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                    },
                    "& .name-column--cell": {
                        color: colors.blueAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.blueAccent[200]} !important`,
                    },
                }}
            >
                <DataGrid checkboxSelection rows={filtered_users} columns={user_columns} />
            </Box>
        </Box>
    );
};

export default TeamManagement;
